export default __webpack_public_path__ + "static/media/association-banner.cf4c6c4e.svg";